import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '@/app/providers/AppContextProvider';
import { formatWage, getEmployeeCounts, getTotalWage } from '@/services/utils';
import type { EmployeeSummary } from '@/types/app';

interface WagesProps {
	loading: boolean;
}

const Wages = ({ loading }: WagesProps) => {
	const { t } = useTranslation();
	const { appData, pendingPremiumVars } = useAppContext();
	const employees = (appData?.premium_variables?.employees?.employee_list ||
		[]) as EmployeeSummary[];
	return (
		<div
			id="wagesContainer"
			data-testid="wages-container"
			className="font-bold text-sm flex flex-col items-end gap-0.5 sm:flex-row sm:items-center sm:justify-start"
		>
			<div className="whitespace-nowrap">
				{t('quotes.settings.employees.wagesLabel')} €
				{loading ? (
					<span className="ml-1">
						{pendingPremiumVars.employeesTotalWage != null
							? formatWage(pendingPremiumVars.employeesTotalWage)
							: getTotalWage(employees)}
					</span>
				) : (
					<span className="ml-1">{getTotalWage(employees)}</span>
				)}
			</div>
			<span className="hidden sm:inline px-1 opacity-25 shrink-0">/</span>
			<div className="flex items-center flex-nowrap whitespace-nowrap">
				<span className="mr-1 sm:mr-2">
					{loading ? (
						<span>{pendingPremiumVars.employeeCount || getEmployeeCounts(employees).count}</span>
					) : (
						<span>{getEmployeeCounts(employees).count}</span>
					)}
				</span>
				<span className="hidden lg:inline">{t('quotes.settings.employees.title')}</span>
				<span className="inline lg:hidden shrink-0">
					<User className="w-3 h-3 text-muted-foreground" />
				</span>
			</div>
		</div>
	);
};

export default Wages;
